import { createResource } from '../core'
import { accountsService } from './accounts.service'

/** TanStack Query for accounts: `useAccounts({ accountType: 'CLIENT' })`, `useAllAccounts()`, `useAccount(id)`, and the write hooks. */
export const accounts = createResource('accounts', accountsService)

export const accountsKeys = accounts.keys
export const accountsQueries = accounts.queries
export const useAccounts = accounts.useList
export const useAllAccounts = accounts.useAll
export const useAccount = accounts.useOne
export const useCreateAccount = accounts.useCreate
export const useUpdateAccount = accounts.useUpdate
export const useDeleteAccount = accounts.useRemove
